import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const activeSubscriptionApi = async () => {
  try {
    const apiLink = `${endpoint}/api/subscription/active`;
    const response = await axios.get(apiLink);
    const data = response.data;

    const dataObject = {
      status: data.status, // active/free-trial/expired
      subscriptionDays: data.subscriptionDays, // number of days from enddate (+ve is for daysRemaining, -ve is for over due days)
      subscription: {
	id: data.subscription.id || "",
        endDate: data.subscription.endDate || null,
        startDate: data.subscription.startDate || null,
        status: data.subscription.status || "",
        stripePaymentIntet: data.subscription.stripePaymentIntet || "",
        stripeSessionId: data.subscription.stripeSessionId || "",
        planName: data.subscription.plan ? data.subscription.plan.name : "",
        planDescription: data.subscription.plan
          ? data.subscription.plan.description
          : "",
        planPrice: data.subscription.plan ? data.subscription.plan.price : "",
        planCurrecyIsoCode: data.subscription.plan
          ? data.subscription.plan.currecyIsoCode
          : "",
        planBillingInterval: data.subscription.plan
          ? data.subscription.plan.billingInterval
          : "",
      },
    };

    return dataObject;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default activeSubscriptionApi;
